
(function () {
  "use strict";

  const STORE_URL = "https://majailana.com";
  const EVENT_NAME = "Maja Lana - Cart Updated";
  const DEBOUNCE_MS = 10000;

  let lastCartSignature = null;
  let lastSentSignature = null;
  let checking = false;
  let sendTimer = null;

  async function getFullCart() {
    const response = await fetch("/cart.js", {
      credentials: "same-origin",
      cache: "no-store"
    });

    if (!response.ok) {
      throw new Error("Não foi possível ler o carrinho.");
    }

    const cart = await response.json();

    const products = cart.items.map(function (item) {
      return {
        ProductName: item.product_title,
        VariantName: item.variant_title,
        VariantID: item.variant_id,
        Quantity: item.quantity,
        ImageURL: item.image,
        ProductURL: STORE_URL + item.url,
        Price: item.price / 100,
        OriginalPrice: item.original_price / 100,
        LineTotal: item.line_price / 100
      };
    });

    const cartPath = products.map(function (item) {
      return item.VariantID + ":" + item.Quantity;
    }).join(",");

    
return {
  Currency: cart.currency,
  ItemCount: cart.item_count,
  Products: products,
  Subtotal: (cart.original_total_price / 100).toFixed(2),
  Total: (cart.total_price / 100).toFixed(2),
  DiscountTotal: (cart.total_discount / 100).toFixed(2),

  DiscountCodes: (cart.cart_level_discount_applications || [])
    .filter(function (discount) {
      return discount.type === "discount_code";
    })
    .map(function (discount) {
      return discount.title;
    }),

  RecoveryURL: STORE_URL + "/cart/" + cartPath
};

  }

  
function cartSignature(cart) {
  return JSON.stringify({
    Products: cart.Products.map(function (product) {
      return [product.VariantID, product.Quantity];
    }),
    Total: cart.Total,
    DiscountTotal: cart.DiscountTotal,
    DiscountCodes: cart.DiscountCodes
  });
}

  async function sendToKlaviyo(expectedSignature) {
    try {
      if (!window.klaviyo ||
          typeof window.klaviyo.isIdentified !== "function" ||
          typeof window.klaviyo.track !== "function") {
        return;
      }

      const identified = await window.klaviyo.isIdentified();

      if (!identified) {
        console.log("Maja & Lana: visitante não identificado.");
        return;
      }

      const cart = await getFullCart();
      const signature = cartSignature(cart);

      // Não enviar dados desatualizados.
      if (signature !== expectedSignature) return;

      // Não enviar carrinhos vazios.
      if (cart.ItemCount === 0) return;

      // Evitar repetir o mesmo evento nesta página.
      if (signature === lastSentSignature) return;

      await window.klaviyo.track(EVENT_NAME, cart);

      lastSentSignature = signature;

      console.log("MAJA KLAVIYO EVENT SENT:", cart);

    } catch (error) {
      console.warn("Maja Klaviyo Tracking:", error);
    }
  }

  function scheduleSend(signature) {
    if (sendTimer) {
      clearTimeout(sendTimer);
    }

    sendTimer = setTimeout(function () {
      sendTimer = null;
      sendToKlaviyo(signature);
    }, DEBOUNCE_MS);
  }

  async function checkCart() {
    if (checking) return;
    checking = true;

    try {
      const cart = await getFullCart();
      const signature = cartSignature(cart);

      if (lastCartSignature === null) {
        lastCartSignature = signature;
        console.log("Maja & Lana: carrinho inicial identificado.");

      } else if (signature !== lastCartSignature) {
        lastCartSignature = signature;

        console.log("MAJA CART UPDATED:", cart);

        scheduleSend(signature);
      }

    } catch (error) {
      console.warn("Maja Cart Tracking:", error);

    } finally {
      checking = false;
    }
  }

  window.MajaCartTracking = {
    getFullCart: getFullCart,
    checkCart: checkCart
  };

  checkCart();
  setInterval(checkCart, 2000);

  console.log("Maja & Lana: monitorização Klaviyo ativa.");
})();
